
export default {

    walletBalance(state){
        return state.walletBalance
    }
}